import React from 'react';
import Row from '@sp/ui/base/rows/Row';

const TwoLineRow = (props) => <Row {...props} minHeight={80} />;

export default TwoLineRow;
